import { Component, OnDestroy, OnInit, ViewChild, TemplateRef,ViewEncapsulation } from "@angular/core";
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonService } from "src/app/services/common/common.service";
import { forkJoin, Subject, Subscription } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AuthService } from "src/app/services/auth/auth.service";
import { AdminRequestService } from "src/app/services/admin-request/admin-request.service";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { MsalService } from "@azure/msal-angular";
import { UserRoleType } from "src/app/enums/user-role-type.enum";
import { UpdateComponentService } from "src/app/shared/updateComponent.module";
import { DynamictableComponent } from "src/app/shared/dynamictable/dynamictable.component";
import { MatTableDataSource } from "@angular/material/table";

import { NgSelectModule } from "@ng-select/ng-select";
import { NgxSpinnerService, NgxSpinnerComponent } from "ngx-spinner";
import { SharedModule } from "src/app/shared/shared.module";
import { SidebarService } from "src/app/services/sidebar/sidebar.service";

@Component({
    selector: "app-admin-request",
    imports: [DynamictableComponent, ReactiveFormsModule, FormsModule, NgSelectModule, SharedModule, NgxSpinnerComponent],
    templateUrl: "./admin-request.component.html",
    styleUrls: ["./admin-request.component.css"]
})
export class AdminRequestComponent implements OnInit, OnDestroy {
  @ViewChild('template') templateRef!: TemplateRef<any>;
  adminRequestForm: FormGroup;
  adminModalRef: BsModalRef;
  data: any[];
  isLoader: boolean = true;
  hasError: any;
  userid: any;
  roleDetails: [{
    roleId: number;
    roleDescription: string;
  }];
  rpfDetails: Array<{
    rpfId: number;
    rpfName: string;
  }>;
  disabledRoleDesc: any;
  roleId: string;
  rpfId: string;
  firstname: any;
  lastname: any;
  selectedRoleDesc: any[];
  selectedRpf: any[];
  prevSelectedRoleDesc: any[];
  userIdToDel: number;
  roleDescToDel: string = null;
  email: any;
  accessId: number;
  RoleIds: number[] = [];
  permissions: {
    adminPermissions: boolean,
    GBSBillingPermissions: boolean,
    BulkRequestPermissions: boolean,
    RaiseRequestPermissions: boolean,
    ViewReportsPermissions: boolean,
    ApprovalDashboardPermissions: boolean
  } = {
      adminPermissions: false,
      GBSBillingPermissions: false,
      BulkRequestPermissions: false,
      RaiseRequestPermissions: false,
      ViewReportsPermissions: false,
      ApprovalDashboardPermissions: false
    }
  roledescription: any;
  rpfName: any;
  comments: any;
  isEdit: boolean;
  isUserValidated: boolean = true;
  formErrors = {
    userid: "",
    firstname: "",
    lastname: "",
    roledescription: "",
    email: "",
    comments: "",
    rpfName: ""
  };
  editprevroledesc: number = 0;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns = [
    { label: 'User ID', propertyName: 'userId' },
    { label: 'First Name', propertyName: 'firstName' },
    { label: 'Last Name', propertyName: 'lastName' },
    { label: 'Role Description', propertyName: 'roleDescription' },
    { label: 'User Email Address', propertyName: 'userEmailAddress' },
    { label: 'Comments', propertyName: 'comments' },
    { label: 'RPF(s)', propertyName: 'rpfNames' },
    {
      label: 'Action', propertyName: 'icon',
      icons: [
        { toolTip: 'Edit User', icon: 'edit', callFrom: 'edit' },
        { toolTip: 'Delete User', icon: 'delete', callFrom: 'delete' }
      ]
    }
  ];

  validationMessages = {
    userid: {
      required: "User Id is required.",
      pattern: "Enter the valid User Id.",
      custommessage: "User ID is already having role assigned."
    },
    firstname: {
      required: "First Name is required.",
      pattern: "Enter the valid First Name."
    },
    lastname:
    {
      pattern: "Enter the valid Last Name."
    },
    roledescription: {
      required: "Role Description is required."
    },
    rpfName: {
      required: "RPF Name is required."
    },
    email: {
      required: "E-mail is required.",
      pattern: "Enter the valid E-mail Id."
    },
  };
  private eventSubscription: Subscription[] = [];
  isAcive: boolean;
  constructor(
    private fb: FormBuilder,
    public commonService: CommonService,
    private modalService: BsModalService,
    private adminRequestService: AdminRequestService,
    private msalService: MsalService,
    private authService: AuthService, private toastr: ToastrService,
    private updateComponentService: UpdateComponentService,
    private spinnerngx: NgxSpinnerService,
    private sideBarService: SidebarService
  ) {
  }
  ngOnDestroy(): void {
    this.eventSubscription.forEach((subscription) => subscription.unsubscribe());
    this.userIdToDel = null;
    this.roleDescToDel = null;
  }

  ngOnInit(): void {
    this.isAcive = false;
    this.adminRequestForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.pattern(/^(?!\s*$)[a-z\s]+$/i)]],
      lastname: ['', [Validators.pattern(/^[a-z\s]+$/i)]],
      comments: [''],
      roledescription: ['', Validators.required],
      rpfName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[uU][pP][sS]\.(com|std)$/i)]],
      userid: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[uU][pP][sS]\.(com|std)$/i)]]
    });
    this.eventSubscription.push(
      this.adminRequestService.getBATRoles().subscribe({
        next: response => {
          this.dataSource.data = response;
          this.isLoader = false;
        }
      })
    );
  };

  openAddModal(template: TemplateRef<any>) {
    this.adminRequestService.getRoleDesc().subscribe(params => {
      this.roleDetails = params;
    })
    this.adminRequestService.getRpfDetails().subscribe(params => {
      this.rpfDetails = [{ rpfId: 0, rpfName: 'All' }, ...params];
    })
    this.clearControls();
    this.adminRequestForm.valueChanges.subscribe((value) => {
      this.logValidationErrors(this.adminRequestForm);
    });
    this.adminModalRef = this.modalService.show(template, { backdrop: "static" });
  }

  openAddModalDel(_accessId: number) {
    this.clearControls();

    this.adminRequestForm.valueChanges.subscribe((value) => {
      this.logValidationErrors(this.adminRequestForm);
    });

    this.userIdToDel = _accessId;

    Swal.fire({
      title: 'Are you sure?',
      text: "You want to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: ' #301504',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteUserRole();
      } else {
        Swal.fire({
          title: "Delete Cancelled.",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        })
      }
    })
  }

  onBlurCustomerID(userid: string) {
    const pattern = /^[a-zA-Z0-9._%+-]+@[uU][pP][sS]\.(com|std)$/i;
    if (pattern.test(userid)) {
      this.checkUserID(userid)
    }
  }
  closePopup() {
    this.accessId = 0
    this.adminModalRef.hide();
    this.userIdToDel = null;
    this.roleDescToDel = null;
    this.adminRequestForm.reset();
    this.isEdit = false;
  }

  logValidationErrors(group: FormGroup = this.adminRequestForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
      if (abstractControl && abstractControl.invalid) {
        const errors = abstractControl.errors;
        if (errors) {
          this.formErrors[key] = '';
          Object.keys(errors).forEach(errorKey => {
            const errorMessage = this.validationMessages[key]?.[errorKey];
            if (errorMessage) {
              this.formErrors[key] = errorMessage;
            }
          });
        }
      }
    });
  }

  clearControls() {
    this.adminRequestForm.controls["userid"].patchValue("");
    this.adminRequestForm.controls["firstname"].patchValue("");
    this.adminRequestForm.controls["roledescription"].patchValue("All");
    this.adminRequestForm.controls["email"].patchValue("");
    this.adminRequestForm.controls["lastname"].patchValue("");
    this.adminRequestForm.controls["comments"].patchValue("");
    this.adminRequestForm.controls["rpfName"].patchValue("All");
  }

 existingRoles: any[] = [];

checkUserID(userId: string) {
  const userIdControl = this.adminRequestForm.get('userid');
  userIdControl.setErrors(null);
  this.adminRequestService.getBATUserDetails(userId).subscribe((result) => {
    const returnData = result || [];
    this.existingRoles = returnData.map(r => ({
      roleId: r.roleId,
      roleDescription: r.roleDescription
    }));
    const selectedRoleIds = (this.selectedRoleDesc || []).map(r => r.roleId);
    const combinedRoleIds = [
    ...this.existingRoles.map(r => r.roleId),
    ...selectedRoleIds
  ];
    var hasAdmin = false;
      returnData.forEach((data: any) => {
      if(data.roleId === 5 || data.roleDescription === "Admin"){
        hasAdmin = true;
      }
    });

    var nonAdminCount = combinedRoleIds.filter(id => id !== 5).length;
    nonAdminCount = this.editprevroledesc == 0 ? nonAdminCount : nonAdminCount - this.editprevroledesc

    if ((!hasAdmin && nonAdminCount > 1) || (hasAdmin && nonAdminCount >= 2)) {
      userIdControl.setErrors({ custommessage: true });
       userIdControl.markAsTouched();
       this.isUserValidated = false;
    } else {
      userIdControl.setErrors(null);
    }

    this.logValidationErrors(this.adminRequestForm);
  });
}





  openDialog(e) {
    if (e.callFrom === 'delete') {
      this.openAddModalDel(e.details.accessId)
    }
    else if (e.callFrom === 'edit') {
      this.EditUserDetails(e.details);
    }
  }

EditUserDetails(userData: any) {
  this.isEdit = true;
  if (!userData) return;

  forkJoin([
    this.adminRequestService.getRoleDesc(),
    this.adminRequestService.getRpfDetails()
  ]).subscribe(([roles, rpfList]) => {
    this.roleDetails = roles;
    this.rpfDetails = [{ rpfId: 0, rpfName: 'All' }, ...rpfList];
    this.accessId = userData.accessId;
    const selectedRoles = this.roleDetails.filter(r => userData.roleId == r.roleId);
    const selectedRpf = this.rpfDetails.filter(r => userData.rpfIds?.includes(r.rpfId));

    this.adminRequestForm.patchValue({
      firstname: userData.firstName || '',
      lastname: userData.lastName || '',
      comments: userData.comments || '',
      roledescription: userData.roleId,
      rpfName: selectedRpf,
      email: userData.userEmailAddress || '',
      userid: userData.userId || ''
    });

    this.selectedRoleDesc = selectedRoles;
    this.selectedRpf = selectedRpf;
    this.editprevroledesc = selectedRoles.filter(r=> r.roleId != 5).length ?? 0;

    this.adminRequestForm.valueChanges.subscribe(value => {
      this.logValidationErrors(this.adminRequestForm);
    });

    this.adminModalRef = this.modalService.show(this.templateRef, { backdrop: "static" });
  });
}



  submitRequest() {
    this.logValidationErrors();
    this.adminRequestForm.markAllAsTouched();
    this.populateValues();
    if (this.adminRequestForm.valid) {
      var jsonData = {
        UserId: this.adminRequestForm.get("userid")!.value,
        FirstName: this.adminRequestForm.get("firstname")!.value,
        LastName: this.adminRequestForm.get("lastname")!.value,
        RoleDescription: this.roleId,
        Email: this.adminRequestForm.get("email")!.value,
        Comments: this.adminRequestForm.get("comments")!.value,
        CreatedBy: this.authService.getUserGDId(),
        RpfIds: this.rpfId,
        AccessId:this.accessId
      };

      this.eventSubscription.push(
        this.adminRequestService.submitAdminRoleRequest(jsonData).subscribe((result) => {
          var returnData = result;
          if (returnData) {
            this.sideBarService.refreshSidebar.next(true);
            Swal.fire({
              title: "Record successfully saved.",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                this.closePopup();
                this.sendFilters();               
              }
            });
          } else {
            Swal.fire({
              title: "Administrative error please contact support.",
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        }),
      );
      this.closePopup();
    }
  }

  onChangeRoleDesc($event: any, userId : string) {
    const hasAdmin = this.selectedRoleDesc.some(role => role.roleDescription === "Admin");
    if ((this.selectedRoleDesc.length > 1 && !hasAdmin) || (this.selectedRoleDesc.length > 2 && hasAdmin)) {
      this.selectedRoleDesc = [...(this.prevSelectedRoleDesc || [])];
      this.toastr.warning('You have reached Maximum Role Selection', 'Warning'); // Warning toast
    }
    if (this.selectedRoleDesc.length == 0)
      this.disabledRoleDesc = true;
    else
      this.disabledRoleDesc = false;
    this.prevSelectedRoleDesc = [...this.selectedRoleDesc];
    this.onBlurCustomerID(userId);
  }

  public onClearAllRoleDesc() {
    this.selectedRoleDesc = [];
    this.disabledRoleDesc = true;;
  }

  public onClearAllRpfDesc() {
    this.selectedRpf = [];
  }
  populateValues() {
    if (this.selectedRoleDesc.length > 1) {
      if (this.selectedRoleDesc.some((e: any) => e.roleId == '0')) {
        this.roleId = "0";
      } else {
        this.roleId = Array.prototype.map.call(this.selectedRoleDesc, s => s.roleId).toString();
      }
    } else {
      this.roleId = this.selectedRoleDesc[0].roleId.toString();
    }
    if (this.selectedRpf.length > 1) {
      if (this.selectedRpf.some((e: any) => e.rpfId == '0')) {
        this.rpfId = "0";
      } else {
        this.rpfId = Array.prototype.map.call(this.selectedRpf, s => s.rpfId).toString();
      }
    } else {
      this.rpfId = this.selectedRpf[0].rpfId.toString();
    }
  }

  sendFilters() {
    this.eventSubscription.push(
      this.adminRequestService.getBATRoles().subscribe({
        next: response => {
          this.dataSource.data = response;
          this.getRoles()
        }
      })
    );
  }

  deleteUserRole(): void {
    this.eventSubscription.push(
      this.adminRequestService.deleteUser(this.userIdToDel)
        .subscribe((result) => {
          var res = result;          
          if (res) {
            this.sideBarService.refreshSidebar.next(true);
            Swal.fire({
              title: "Record Deleted successfully.",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                this.eventSubscription.push(
                  this.adminRequestService.getBATRoles().subscribe({
                    next: response => {
                      this.dataSource.data = response;
                      this.getRoles();                     
                    }
                  })
                );
              }
            });
          } else {
            Swal.fire({
              title: "Administrative error please contact support.",
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        })
    );
    this.userIdToDel = null;
    this.roleDescToDel = null;

  }

  getRoles(): void {
    this.RoleIds = [];
    this.permissions =
    {
      adminPermissions: false,
      GBSBillingPermissions: false,
      BulkRequestPermissions: false,
      RaiseRequestPermissions: false,
      ViewReportsPermissions: false,
      ApprovalDashboardPermissions: false
    }
    this.data.filter(element => element.userId == this.msalService.instance.getActiveAccount().username.toString())
      .forEach(element => {
        this.RoleIds.push(element.roleId);
      });
    if (this.RoleIds.includes(UserRoleType.Admin)) {
      this.permissions.adminPermissions = true;
    }
    if (this.RoleIds.includes(UserRoleType.AE_User) || this.RoleIds.includes(UserRoleType.RPF_Billers) || this.RoleIds.includes(UserRoleType.Operations_Manager)
      || this.RoleIds.includes(UserRoleType.Sales_Support) || this.RoleIds.includes(UserRoleType.Finance_User) || this.RoleIds.includes(UserRoleType.Pricing) || this.RoleIds.includes(UserRoleType.Finance_Manager)) {
      this.permissions.RaiseRequestPermissions = true;
    }
    if (this.RoleIds.includes(UserRoleType.Operations_Manager) || this.RoleIds.includes(UserRoleType.Operations_Regional_Manager)
      || this.RoleIds.includes(UserRoleType.Finance_Director) || this.RoleIds.includes(UserRoleType.Finance_Manager)) {
      this.permissions.ApprovalDashboardPermissions = true
    }
    if (this.RoleIds.includes(UserRoleType.GBS_Billing) || this.RoleIds.includes(UserRoleType.GBS_Collection)) {
      this.permissions.GBSBillingPermissions = true
    }
    this.updateComponentService.sendUpdate(this.permissions);
  }

showSpinner() {
  this.spinnerngx.show('upsSpinner', {
    type: 'custom',
    size: 'medium',
    bdColor: 'rgba(255, 255, 255, 0.8)',
    color: '#321815',
    template: '<app-spinner></app-spinner>'
  });
}

hideSpinner() {
  this.spinnerngx.hide('upsSpinner');
}
onSpinnerDone() {
  this.isLoader = false;
  this.spinnerngx.hide('upsSpinner'); // hide from service
}
}
